import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  state() {
    return {
      monitoringList: [],
      monitoringStatus: null,
      monitoringInfo: JSON.parse(sessionStorage.getItem('monitoringInfo')) || {},
      monitoredList: {
        list: [],
        count: 0,
      },
      monitoredNotice: {
        list: [],
        count: 0,
      },
    };
  },
  mutations,
  actions,
  getters,
  namespaced: true,
};
